import { Formik, FormikProps } from 'formik';
import { SubPageHandle, useFormikSubPage } from '@synergy/utils';
import { forwardRef, useRef } from 'react';

import * as SupplierDetailOverviewActions from '../overview/store/supplier-detail-overview-actions';
import { PaloDirtyComparison } from '../../../../../common/components/palo/palo-dirty-context';
import { SupplierDetailOverviewAddress } from '../overview/components/supplier-detail-overview-address';
import { SupplierDetailOverviewFormValues } from '../overview/models/supplier-detail-overview-form-values';
import {
    supplierDetailOverviewBaselineSelector,
    supplierDetailOverviewFormDataSelector,
} from '../overview/store/supplier-detail-overview-selectors';
import { supplierDetailOverviewValidationSchema } from '../overview/supplier-detail-overview-validation-schema';
import { useAppSelector } from '../../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../../store/use-thunk-dispatch';

/**
 * The supplier's addresses, on a tab of their own as the member's (#2261).
 * They are part of the same record as the details — this tab works on the
 * form the details park in the store, so one save keeps both.
 */
export const SupplierDetailAddresses = forwardRef<SubPageHandle, Record<string, unknown>>((_, ref) => {
    const dispatch = useThunkDispatch();
    const formikRef = useRef<FormikProps<SupplierDetailOverviewFormValues>>(null);
    const { formValues, errors, touched } = useAppSelector(supplierDetailOverviewFormDataSelector);
    const baseline = useAppSelector(supplierDetailOverviewBaselineSelector);

    useFormikSubPage(ref, formikRef, (values, isDirty, isValid, errs) => {
        dispatch(SupplierDetailOverviewActions.updateSupplierDetail(values, isDirty, isValid, errs));
    });

    return (
        <Formik
            onSubmit={() => Promise.resolve()}
            initialValues={formValues}
            validationSchema={supplierDetailOverviewValidationSchema}
            enableReinitialize={true}
            initialErrors={errors}
            initialTouched={touched}
            innerRef={formikRef}
        >
            {() => (
                <>
                    {/* Only the addresses: the rest of the record has its mark on
                        the details, where it is entered. */}
                    <PaloDirtyComparison<SupplierDetailOverviewFormValues>
                        baseline={baseline?.addresses}
                        normalize={values => values.addresses}
                    />
                    <SupplierDetailOverviewAddress />
                </>
            )}
        </Formik>
    );
});
